import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { PageHeader, UnvButton, Badge, Card } from 'components'
import styles from './ReportsPage.module.scss'

const ReportsPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('common')

  const CARDS = [
    {
      key: 'form-1nk',
      title: t('reports.card_form1nk_title'),
      description: t('reports.card_form1nk_desc'),
      path: '/reports/form-1nk',
      badge: t('reports.badge_report'),
      badgeVariant: 'info',
    },
    {
      key: 'contingent',
      title: t('reports.card_contingent_title'),
      description: t('reports.card_contingent_desc'),
      path: '/reports/contingent',
      badge: t('reports.badge_report'),
      badgeVariant: 'info',
    },
    {
      key: 'accreditation',
      title: t('reports.card_accreditation_title'),
      description: t('reports.card_accreditation_desc'),
      path: '/reports/accreditation',
      badge: t('reports.badge_kpi'),
      badgeVariant: 'success',
    },
    {
      key: 'curator',
      title: t('reports.card_curator_title'),
      description: t('reports.card_curator_desc'),
      path: '/curator-drilldown',
      badge: t('reports.badge_analytics'),
      badgeVariant: 'accent',
    },
    {
      key: 'audit',
      title: t('reports.card_audit_title'),
      description: t('reports.card_audit_desc'),
      path: '/admin/',
      badge: t('reports.badge_audit'),
      badgeVariant: 'warning',
    },
  ]

  return (
    <div className={styles.page}>
      <PageHeader
        title={t('reports.page_title')}
        subtitle={t('reports.page_subtitle')}
      />

      <div className={styles.grid}>
        {CARDS.map((card) => (
          <Card key={card.key} className={styles.card}>
            <div className={styles.cardHead}>
              <div className={styles.cardTitle}>{card.title}</div>
              {card.badge && <Badge variant={card.badgeVariant}>{card.badge}</Badge>}
            </div>
            <div className={styles.cardDesc}>{card.description}</div>
            <UnvButton
              variant="primary"
              iconLeft="arrow-right"
              onClick={() => navigate(card.path)}
              className={styles.cardBtn}
            >
              {t('reports.open_btn')}
            </UnvButton>
          </Card>
        ))}
      </div>
    </div>
  )
}

export default ReportsPage
